<template>
    <div class="measurements-selector__modal" id="modal-store" aria-hidden="true" role="dialog">
        <div class="measurements-selector__modal-overlay"></div>
        <div class="measurements-selector__modal-window" role="document">
            <div class="measurements-selector__modal-header">
                <h2 class="measurements-selector__modal-title">{{ i18n.storeConfiguration }}</h2>
                <a class="measurements-selector__modal-close btn btn--secondary btn--highlight-icon btn--js-modal-close" :aria-label="i18n.closeModal">
                    <span class="btn__icon">
                        <span class="icon icon-close"></span>
                    </span>
                </a>
            </div>
            <div class="measurements-selector__modal-body">
                <div v-if="!hasShortLink || hasAlteredConfiguration">
                    <label for="measurements-selector-config-name">
                        {{ i18n.storeConfigurationName }}
                    </label>
                    <div class="measurements-selector__store">
                        <input
                            id="measurements-selector-config-name"
                            class="measurements-selector__store-name"
                            type="text"
                            name="ConfigurationName"
                            ref="storeConfigName"
                            v-model="name"
                            required
                        />
                        <button
                            class="btn btn--secondary btn--small"
                            type="button"
                            v-on:click="storeConfig()"
                            :aria-label="i18n.storeConfigurationButton"
                        >
                            <span class="btn__text">
                                {{ i18n.storeConfigurationButton }}
                            </span>
                        </button>
                    </div>
                </div>
                <validation-message
                    v-if="invalidName"
                    input-id="measurements-selector-config-name"
                >
                    {{ i18n.storeConfigurationNameRequired }}
                </validation-message>
                <div class="measurements-selector__share-link" v-if="hasShortLink && !hasAlteredConfiguration">
                    {{ i18n.storeConfigurationSucces }}
                </div>
				<div>
					<a :href="myAcccountConfigurations">
						{{ i18n.storeConfigurationLink }}
					</a>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
	data() {
		return {
			name: '',
			myAcccountConfigurations: window.measurementSelectorVariables.storedConfigurationsUrl,
			invalidName: false,
		};
	},
	computed: {
		i18n() { return this.$i18n; },
		hasShortLink() {
			return this.shortLink !== '' && this.shortLink !== undefined;
		},
		...mapGetters([
			'hasAlteredConfiguration',
			'measurementsConfig',
			'configurationName',
			'stringifiedConfig',
			'shortLink',
		]),
	},
	methods: {
		...mapActions([
			'createConfigurationLink',
		]),
		...mapMutations([
			'updateConfigurationName',
		]),
		async storeConfig() {
			if (this.name) {
				this.invalidName = false;
				this.$store.commit('updateConfigurationName', this.name);
				await this.generateConfigurationLink();
			} else {
				this.invalidName = true;
				this.$refs.storeConfigName.focus();
			}
		},
		async generateConfigurationLink() {
			await this.$store.dispatch('createConfigurationLink');
		},
	},
};
</script>
